<template>
  <v-col cols="12" class="pl-4 pb-0" style="background-color: #e6e7e8 !important; min-width: 1000px !important;" >
    <v-col cols="12" class="py-0 d-flex justify-end pr-0">
      <v-col cols="11" class="py-0">
        <v-container fluid class="py-0 ">
          <v-row class="py-0  mt-0 mb-0 row-style" align="center">
            <v-col cols="auto" class="py-0">
              <h3 class="header_dims page_headers pr-0 mr-0 pt-0 mt-0">
                {{ $t("navbar.navdrawer.Widgets") }}&nbsp;
              </h3>
            </v-col>
            <v-col cols="1" class="pl-0 ml-0 py-0">
              <TooltipIcon
                :posRight="true"
                :nudgeBottom="30"
                :nudgeLeft="5"
                :txt="$t('widgets.headerInfo')"
                class="infoicon_scale pt-0"
              />
            </v-col>

            <v-col cols="8.75" class="py-0">
              <v-row align="center" justify="end" style="width:100%" class="py-0">
                <v-col cols="auto" class="py-0"> </v-col>
                <v-col cols="auto" class="py-0">
                  <span><CartAttempts class="pt-0 pr-6"/></span
                  ></v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-col>
    <v-col cols="12" class="py-0">
      <v-row class=" pt-0 mt-0 pb-0 mb-0 row-style" align="center">
        <v-col cols="auto" class="popup_wdg_card pt-0 pb-0 par_title_popup_consent d-flex align-center" >
          <h3 class="title_popup_consent  pr-0 mr-0 pt-0 mt-0">
            {{ $t("widgets.PopupConsentWidget") }}&nbsp;
          </h3>

          <TooltipIcon
            :posRight="true"
            :nudgeBottom="30"
            :nudgeLeft="5"
            :txt="$t('widgets.headerInfo2')"
            class="infoicon_scale pt-0 ml-3"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="py-0 d-flex justify-end" style="background-color: #F2F2F2;">
      <v-col cols="11" class="py-0 px-0">
        <v-container fluid class="pt-0 px-0">
          <v-row
            class="pt-1 px-0 bg_wdg_cards"
            align="start"
            justify="start"
            style="height:auto; width:100%"
          >
            <v-col cols="6" style="height:100%" class="pt-1 pl-2">
              <v-row style="height:100%" align="start" justify="start">
                <WidgetProps class="mt-3" />
              </v-row>
            </v-col>
            <v-col cols="6" style="" class="pt-1 pr-0 pos_sticky">
              <v-row
                style="height:75vh; width:auto; "
                align="start"
                justify="center"
                v-show="widgetType == 'Button'"
              >
                <WidgetView />
              </v-row>
              <v-row
                style=" width:auto;"
                align="start"
                justify="center"
                v-show="widgetType == 'Checkbox'"
              >
                <v-col class="d-flex justify-center wdgt_top_text" v-if="triggerPopup.add_to_cart == true && triggerPopup.exit_intent == false">{{$t('widgets.widgetViewCheckboxTopText.addToCart')}}</v-col>
                <v-col class="d-flex justify-center wdgt_top_text" v-if="triggerPopup.add_to_cart == false && triggerPopup.exit_intent == true">{{$t('widgets.widgetViewCheckboxTopText.exitIntent')}}</v-col>
                <v-col class="d-flex justify-center wdgt_top_text" v-if="triggerPopup.add_to_cart == true && triggerPopup.exit_intent == true">{{$t('widgets.widgetViewCheckboxTopText.both')}}</v-col>

               <WidgetViewCheckBox />
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>

    </v-col>
  </v-col>
</template>

<script>
import TooltipIcon from "@/components/svgIcons/TooltipIcon.vue";
import WidgetProps from "@/components/Widgets/WidgetProps.vue";
import WidgetView from "@/components/Widgets/WidgetView.vue";
import WidgetViewCheckBox from "@/components/Widgets/WidgetViewCheckBox.vue";
import { mapGetters } from "vuex";
import CartAttempts from "@/components/AbandonedCarts/CartAttempts.vue";

export default {
  name: "Widgets",
  components: {
    TooltipIcon,
    WidgetProps,
    WidgetView,
    WidgetViewCheckBox,
    CartAttempts
  },
  data() {
    return {
      live: false
    };
  },
  beforeCreate() {
    this.$store.dispatch("getWidgets").then(() => {
      // console.log(response);
      this.live = this.$store.getters.getWidgetsState.active;
    });
  },
  mounted () {
    window.scrollTo(0,0);
  },
  methods: {
    updWdgtLiveActive() {
      this.$store.dispatch("updWdgtLive", this.live).then(() => {
        this.$store.dispatch("setWdgts").then(() => {
          this.$store.dispatch("getWidgets");
        });
      });
    }
  },
  computed: {
    ...mapGetters(["getWidgetsState"]),
    widgetType() {
      // console.log(
      //   "widget type :: " + this.getWidgetsState.facebook_widget_type
      // );
      return this.getWidgetsState.facebook_widget_type;
    },
    triggerPopup(){
      return this.getWidgetsState.popup_triggers
    },
    liveLbl() {
      return this.live ? this.$t("widgets.liveLbl") : this.$t("widgets.offLbl");
    }
  }
};
</script>

<style scoped>
.pos_sticky{
  position: sticky;
  top: -120px;
}
.popup_wdg_card{
  margin-left: 6% !important;
  padding-left: 3.5% !important;
}
.row-style {

}
.bg_wdg_cards{
  background: #F2F2F2 0% 0% no-repeat padding-box;
}
.par_title_popup_consent{
  width: 400px;
  height: 77px;
  background: #F2F2F2 0% 0% no-repeat padding-box;
  opacity: 1;
  border-bottom: 2px solid #006AFF;
}
.title_popup_consent{
  text-align: left;
  font: normal normal bold 15px/25px Poppins;
  letter-spacing: 0px;
  color: #006AFF;
  opacity: 1;
}
.wdgt_top_text{
  text-align: center;
  font: normal normal medium 16px/24px Poppins !important;
  font-weight: Medium;
  letter-spacing: 0px !important;
  color: #323F4F !important;
  opacity: 1;
}
@media (max-width: 1449px) {
  .popup_wdg_card{
    margin-left: 6% !important;
    padding-left: 4.2% !important;
  }
}
@media (max-width: 1280px) {
  .wdgt_top_text{
    font-size: 13px !Important;
  }
}
@media screen and (max-height: 830px) {
  .pos_sticky{
    position: sticky;
    top: -190px !important;
  }
}
@media screen and (max-height: 630px) {
  .pos_sticky{
    position: sticky;
    top: -290px !important;
  }
}
</style>
